import gql from "graphql-tag";

export const RebateFragment = gql`
  fragment Rebate on Rebate {
    id
    name
  }
`;
